import { render } from "./FactPanel.vue?vue&type=template&id=d9b4653c&scoped=true"
import script from "./FactPanel.vue?vue&type=script&lang=js"
export * from "./FactPanel.vue?vue&type=script&lang=js"

import "./FactPanel.vue?vue&type=style&index=0&id=d9b4653c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9b4653c"]])

export default __exports__